export default  {
    bindings: {
        item: '<',
        existingEvents: '<',
        names: '<',
        all: '<',
        formType: '@',
        formTab: '=',
        description: '@',
        events: '<'
    },
    controller: 'eventMultiSelectFormController',
    template: require('../views/event.multiSelect.form.html')
};



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/event/components/event.multiSelect.form.component.js